import { Box, Grid, Paper, Radio, RadioGroup, TextField, FormControl, FormControlLabel, } from "@mui/material";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ApiService from "../../functions/apiService";
import { Controller, useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import PageLoader from "../../components/PageLoader/PageLoader";
import MultiSelectInput from "../../components/MultiSelect/MultiSelect";
import CustomGroupForm from "../../components/CustomGroupForm/CustomGroupForm";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

export default function Messaging() {
  const [customGroupModalOpen, setCustomGroupModalOpen] = useState(false);
  // const { enqueueSnackbar } = useSnackbar();
  let navigate = useNavigate();
  const {
    register, formState: { errors }, control, handleSubmit, setError, getValues, reset,
    formState: { isDirty, isValid }
  } = useForm({
    defaultValues: {
      sendTo: [],
    },
  });
  const [headers, setHeaders] = useState();
  const [sendTo, setSendTo] = useState();
  const [receiver, setReceiver] = useState();
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [isSendToRequired, setIsSendToRequired] = useState();
  const [activeTab, setActiveTab] = useState('sendMessage')

  useEffect(() => {
    setLoading(true);
    ApiService.get("/getMessageTo").then(({ data }) => {
      setSendTo(data.data);
      setHeaders(Object.keys(data.data));
      setLoading(false);
    });
  }, []);

  const checkBoxCheckedEvent = (e) => {
    if (e.target.value === "Each Member") {
      setIsSendToRequired(false);
      setCustomGroupModalOpen(false);
    } else if (e.target.value.includes("Custom")) {
      setCustomGroupModalOpen(true);
    } else {
      setIsSendToRequired(true);
      setCustomGroupModalOpen(false);
    }
  };

  const onSubmit = (d, event) => {
    event.preventDefault();
    event.stopPropagation();
    setSending(true)
    let data = {
      header_type: d.header_type,
      message: d.message,
      sendBy: d.sendBy,
    };
    let values = [];
    d.sendTo.map((item) => {
      values.push(item.value);
    });
    data = { ...data, sendTo: values };
    ApiService.post("/sendMessage", data)
      .then((data) => {
        setSending(false)
        toast.success("Message sent successfully")
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch(({ data }) => {
        setSending(false)
        toast.error(data?.message)
        // enqueueSnackbar("Error", { variant: "error" });
        setError("message", { type: "manual", message: data.message });
      });
  };

  return (
    <>
      <Paper className="p-3" style={{ marginTop: "1rem" }}>
        <Row>
          <Col md={9} sm={10} xs={10} style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '200px' }} className={'tab-active'}>
              Send A Message
            </div>
            <div style={{ width: '190px' }} className={'tab-white mx-2'}
              onClick={() => navigate("/firehouse/user-messages")}>
              User Messages
            </div>
          </Col>
        </Row>
        <Typography variant="h6" className="mb-2 mt-4">Send a Message</Typography>
        {loading == true ?
          <Box className="w-100 d-flex justify-content-center align-items-center"
            style={{ height: '460px' }}>
            <PageLoader />
          </Box>
          :
          <form
            onSubmit={handleSubmit((data, event) => {
              onSubmit(data, event);
            })}
          >
            <Grid item columns={{ xs: 12, sm: 12, md: 12 }}>
              <FormControl sx={{ gap: "12px" }}>
                <RadioGroup
                  value={receiver}
                  onChange={(e) => {
                    checkBoxCheckedEvent(e);
                    setReceiver(e.target.value);
                  }}
                  name="radio-buttons-group"
                  row
                >
                  {headers &&
                    headers.map((item) => (
                      <FormControlLabel
                        value={item}
                        {...register("header_type")}
                        key={item}
                        control={<Radio />}
                        label={
                          <Typography
                            sx={{
                              textTransform:
                                "capitalize",
                            }}
                          >
                            {item.toLowerCase()}
                          </Typography>
                        }
                      />
                    ))}
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid
              container
              spacing={2}
              columns={{ xs: 12, sm: 12, md: 12 }}
              sx={{ padding: "1rem 0 0 0" }}
            >
              <Grid
                className="pt-2"
                item
                xs={8}
                sm={8}
                md={8}
                sx={{ minHeight: "60px" }}
              >
                {customGroupModalOpen == true ? (
                  <CustomGroupForm
                    array={
                      sendTo ? sendTo["Employee"] : []
                    }
                  />
                ) : (
                  <>
                    {customGroupModalOpen}
                    <MultiSelectInput
                      size="small"
                      array={
                        sendTo && receiver
                          ? sendTo[receiver]
                          : []
                      }

                      register={register}
                      required={
                        getValues()[
                          "header_type"
                        ] == "Each Member"
                          ? false
                          : true
                      }
                    />
                  </>
                )}
                {errors.sendTo && (
                  <p style={{ color: "red" }}>
                    {errors.sendTo?.message}
                  </p>
                )}
              </Grid>

              <Grid
                item
                xs={8}
                sm={8}
                md={8}
                sx={{
                  minHeight: "160px",
                }}
              >
                <label className="my-2">Message</label>
                <TextField
                  className="w-100"
                  multiline
                  rows={4}
                  {...register("message", {
                    required: "message is required",
                    minLength: 10,
                    pattern: /[\w\d]+/,
                  })}
                  placeholder="Enter your message"
                />
                {errors.message && (
                  <p style={{ color: "red" }}>
                    {errors.message?.message}
                  </p>
                )}
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Controller
                  control={control}
                  name="sendBy"
                  size='small'
                  rules={{
                    required:
                      "At leaast one send by should be selected",
                  }}
                  render={({ field }) => (
                    <RadioGroup
                      {...field}
                      className="d-flex flex-row "
                    >
                      <FormControlLabel
                        value="Push"
                        control={<Radio />}
                        label="Push"
                      />
                      <FormControlLabel
                        value="SMS"
                        control={<Radio />}
                        label="Text & Push"
                      />
                      <FormControlLabel
                        value="Email"
                        control={<Radio />}
                        label="Email"
                      />
                    </RadioGroup>
                  )}
                />
                {errors.sendBy && (
                  <p style={{ color: "red" }}>
                    {errors.sendBy?.message}
                  </p>
                )}
              </Grid>
            </Grid>


            <div className="d-flex justify-content-start my-3">
              <ButtonTheme
                type="submit"
                color="primary"
                // isSendToRequired &&
                disabled={isValid == true && !sending ? false : true}
                style={{
                  width: "140px",
                  textTransform: "capitalize",
                }}
              >

                {sending ? 'Loading...' : 'Send'}
              </ButtonTheme>
            </div>
          </form>
        }
      </Paper>
    </>
  );
}
